import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authenticate');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-authenticate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authenticate/view.scss */
/* src/app/page.authenticate/view.scss: no such file or directory */`],
})
export class PageAuthenticateComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public returnTo: string = "notset";

    public view: string = 'login.email';

    public data: any = {
        email: '',
        password: ''
    };
    public alert: any;

    public userOptional = [
        { key: 'institute', label: '소속기관', placeholder: '한국과학기술연구원' },
        { key: 'department', label: '부서', placeholder: '과학기술연구망센터' },
        { key: 'title', label: '직책', placeholder: '책임연구원' },
        { key: 'mobile', label: '휴대전화', placeholder: '010-1234-5678' },
        { key: 'tel', label: '유선전화', placeholder: '042-123-4567' },
        { key: 'fax', label: '팩스번호', placeholder: '042-123-4567' }
    ]

    public async ngOnInit() {
        await this.service.init();
        this.title.setTitle('MY KREONET');
        let returnTo = this.getParam('returnTo', '/dashboard');
        let check = await this.service.auth.allow(false, returnTo);
        if (check) this.returnTo = returnTo;
        this.alert = this.service.alert;
        await this.service.render();
        if (this.service.auth.session.insert) {
            await this.service.alert.success(this.service.auth.session.insert);
            await wiz.call("clear");
            await this.service.render();
        } else if (this.service.auth.session.pending) {
            await this.service.alert.success(this.service.auth.session.pending);
            await wiz.call("clear");
            await this.service.render();
        } else if (this.service.auth.session.block) {
            await this.service.alert.error(this.service.auth.session.block);
            await wiz.call("clear");
            await this.service.render();
        }
    }

    public getParam(sname, defaultvalue) {
        let params = location.search.substring(location.search.indexOf("?") + 1);
        let sval = defaultvalue;
        params = params.split("&");
        for (let i = 0; i < params.length; i++) {
            let temp = params[i].split("=");
            if ([temp[0]] == sname) { sval = temp[1]; }
        }
        return decodeURIComponent(sval);
    }

    public async toLogin() {
        this.view = 'login.email';
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (user.password)
            user.password = this.service.auth.hash(user.password);
        else
            delete user.password;

        let { code, data } = await wiz.call("login", user);
        if (code == 200) {
            if (data == 'dormant') {
                this.view = "login.terms"
                await this.service.render();
            } else {
                location.href = this.returnTo;
            }

        } else if (code == 201) {
            this.view = "login.password";
            await this.service.render();
            try {
                setTimeout(() => {
                    document.querySelector("input[type=password]").focus();
                }, 150);
            } catch (err) {
            }
        } else if (code == 301) {
            let isjoin = await this.alert.warning(data, '닫기', '계정 만들기');
            if (!isjoin) return;
            this.view = "join.terms";
            await this.service.render();
        } else {
            await this.alert.error(data);
        }
    }

    public async join_start() {
        this.view = "join.email";
        let { code, data } = await wiz.call("get");
        this.file = data;
        await this.service.render();
    }

    public async join_email_check() {
        let user = JSON.parse(JSON.stringify(this.data));
        delete user.password;
        let { code, data } = await wiz.call("login", user);
        if (code == 301) {
            this.view = "join.terms";
            await this.service.render();
            return;
        }

        await this.alert.warning("사용할 수 없는 이메일입니다.");
    }

    public async termsAccept() {
        this.view = "join.verify";
        await this.emailAuthentication(this.data.email, false);
        await this.service.render();
    }

    public async loginTerms(email: string) {
        let { code, data } = await wiz.call("term_update", { email });
        location.href = this.returnTo;
    }

    public async emailAuthentication(email: string, showstatus: boolean = true) {
        await this.service.loading.show();
        let res = await wiz.call('emailAuthentication', { email });
        await this.service.loading.hide();
        if (!showstatus) return;
        if (res.code == 200) {
            await this.alert.success("이메일 인증 코드가 발송되었습니다.");
        } else {
            await this.alert.error("이메일 인증 코드 발송중 오류가 발생했습니다.");
        }
    }

    public async emailVerify(email: string, onetimepass: string) {
        await this.service.loading.show();
        let res = await wiz.call('emailVerify', { email, onetimepass });
        await this.service.loading.hide();
        if (res.code == 200) {
            this.view = "join.userrequired";
            await this.service.render();
        } else {
            await this.alert.error(res.data);
        }
    }

    public async checkUserInfo() {
        if (!this.data.name || this.data.name.length == 0) return await this.alert.error("이름을 입력해주세요");
        if (!this.data.password || this.data.password.length == 0) return await this.alert.error("비밀번호를 입력해주세요");
        let password = this.data.password;
        let password_re = this.data.password_repeat;
        if (password.length < 8) return await this.alert.error("8글자 이상의 비밀번호를 설정해주세요");
        if (password.search(/[a-z]/i) < 0) return await this.alert.error("비밀번호에 알파벳을 포함해주세요");
        if (password.search(/[0-9]/) < 0) return await this.alert.error("비밀번호에 숫자를 포함해주세요");
        if (password != password_re) return await this.alert.error("비밀번호가 일치하지 않습니다");

        let user = JSON.parse(JSON.stringify(this.data));
        delete user.password_repeat;

        user.password = this.service.auth.hash(user.password);

        await this.service.loading.show();
        let { code, data } = await wiz.call("saveUserInfo", user);
        await this.service.loading.hide();

        if (code != 200) {
            return await this.alert(data);
        }

        this.view = "join.useroptional";
        await this.service.render();
    }

    public async join() {
        let user = JSON.parse(JSON.stringify(this.data));
        delete user.password_repeat;

        let { code } = await wiz.call("join", user);

        if (code == 200) {
            await this.alert.success("회원가입이 완료되었습니다. 관리자 승인 후 로그인 가능합니다.");
            location.reload();
        } else {
            await this.alert.error(data);
        }
    }
}

export default PageAuthenticateComponent;